import React from 'react';
import { Collapse } from 'react-bootstrap';
import { MedFormInOrderSet } from '../../../../../components/Users/MedForm';
import AsyncSelect from 'react-select/async';
import { mapToMedicationDetails } from '../../../../../components/Users/OrderSetForm/helper';
import { useForm } from 'react-hook-form';
import { useGetAllCatalogMeds } from '../../../../../components/Users/MedicationOrderSets/hooks';
import { defaultMedSectionBreak } from '../../../types';
import { IMPORTANT_PATIENT_INFORMATION } from '../../../constants';

const AddMedicationForm = ({
  open,
  onClose,
  medicationProfileForm,
  onSave,
}) => {
  const { watch } = medicationProfileForm;
  const { postGetAllCatalogMeds } = useGetAllCatalogMeds();
  const sectionsData = watch('medSections');
  const sectionOptions = sectionsData
    .filter(
      (section) => section.medSectionBreak !== IMPORTANT_PATIENT_INFORMATION,
    )
    .map((section) => ({
      value: section.medSectionBreak,
      label: section.medSectionBreak,
    }));
  const resolvedSectionOptions =
    sectionOptions.length > 0
      ? sectionOptions
      : [{ value: defaultMedSectionBreak, label: defaultMedSectionBreak }];

  const medForm = useForm();
  const { watch: medFormWatch } = medForm;
  const selectedMedWatch = medFormWatch('selectedMed');
  const loadMedicineOptions = async (inputValue) => {
    if (inputValue && inputValue.length > 3) {
      const result = await postGetAllCatalogMeds({
        filterPayload: {
          medName: inputValue,
        },
      });
      return result.map((item) => {
        return {
          label: item.med_name,
          value: mapToMedicationDetails(item),
        };
      });
    }
    return [];
  };
  return (
    <Collapse
      in={open}
      onEntered={() =>
        window.dispatchEvent(new Event('caremappr:collapse-entered'))
      }
    >
      <div>
        <div className="px-2 d-flex flex-column gap-2">
          <span className="my-2 medication-profile-font-gray row-action-font">
            Add Medication
          </span>
          {!selectedMedWatch ? (
            <div className="med-form-container-row">
              <div className="filterItem">
                <label className="txtDropdownLabel">
                  Medication name and strength
                </label>
                <div className="view-width-30">
                  <AsyncSelect
                    isMulti={false}
                    placeholder={'Start typing and select'}
                    cacheOptions
                    defaultOptions
                    isClearable
                    loadOptions={(inputValue) =>
                      loadMedicineOptions(inputValue)
                    }
                    onChange={(selectedOptions) => {
                      if (selectedOptions && selectedOptions.value) {
                        medForm.setValue(
                          'selectedMed',
                          // @ts-expect-error
                          selectedOptions.value,
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <MedFormInOrderSet
              data={selectedMedWatch}
              sectionOptions={resolvedSectionOptions}
              onOrderSetModeChange={(data) => {
                const targetSection = data.medSectionBreak;
                onSave(data, targetSection);
                medForm.reset();
                onClose();
              }}
              onCancelEdit={() => {
                medForm.reset();
                onClose();
              }}
              showFurtherInform={false}
              requiredSection={true}
            />
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default AddMedicationForm;
